export default __webpack_public_path__ + "static/media/my-profile.a909bd8c.png";